<template>
  <div
    id="ranges"
    class="row"
  >
    <v-row justify="center">
      <v-col
        cols="12"
        sm="12"
        md="10"
        lg="9"
      >
        <v-form
          ref="form"
          v-model="valid"
          lazy-validation
          @submit.prevent="reset"
          @keydown="form.onKeydown($event)"
        >
          <v-container grid-list-xl>
            <form-toolbar
              :title="title"
              :loading="form.busy"
              @save="save"
              @cancel="cancel"
            />
            <v-layout
              :id="ref"
              class="wrap justify-space-around form-body"
            >
              <v-col
                cols="12"
                md="12"
              >
                <v-autocomplete
                  v-model="form.method"
                  :rules="[rules.required]"
                  :items="itemsMethod"
                  label="Método de Pago"
                  item-value="code"
                  item-text="name"
                  required
                  >
                </v-autocomplete>
              </v-col>
              <v-col
                cols="12"
                md="12"
              >
                <v-autocomplete
                  v-model="form.bank_code"
                  :rules="[rules.required]"
                  :items="itemsBank"
                  label="Banco"
                  item-value="code"
                  item-text="name"
                  required
                  >
                  <template v-slot:selection="data">
                    {{ data.item.code }} - {{ data.item.name }}
                  </template>
                  <template v-slot:item="data">
                    {{ data.item.code }} - {{ data.item.name }}
                  </template>
                </v-autocomplete>
              </v-col>
              <v-col
                cols="12"
                md="12"
              >
                <v-text-field
                  v-model="form.bank_account"
                  :rules="[rules.required]"
                  label="Cuenta del Banco"
                  placeholder="Cuenta del Banco"
                  maxlength="24"
                  v-mask="'####-####-##-##########'"
                />
              </v-col>
              <v-col
                cols="12"
                md="6"
              >
                <v-text-field
                  v-model="form.user"
                  :rules="[rules.required]"
                  label="Usuario"
                  placeholder="Usuario"
                  required
                  maxlength="50"
                />
              </v-col>
              <v-col
                cols="12"
                md="6"
              >
                <v-text-field
                  v-model="form.password"
                  :rules="[rules.required]"
                  type="password"
                  label="Contraseña"
                  placeholder="Contraseña"
                  required
                  maxlength="100"
                />
              </v-col>
            </v-layout>
          </v-container>
        </v-form>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { mask } from 'vue-the-mask';
import Form from 'vform';
import FormToolbar from '~/components/Form/Toolbar';

export default {
    directives: {
      mask,
    },
    components: {
      FormToolbar,
    },
    props: {
      enterpriseId: { default: '' },
      id: { default: '' },
    },
    data: () => ({
      form: new Form({
        id: '',
        method: 'SYPAGO',
        bank_code: '0102',
        bank_name: '',
        password: '',
        bank_account: '',
        busy: false,
        active: 1,
      }),
      valid: false,
      rules: {
        required: (v) => !!v || 'El campo es requerido.',
      },
      itemsBank: [],
      itemsMethod: [{ code: 'SYPAGO', name: 'SYPAGO' }],
      buttons: [
        {
          icon: 'mdi-content-save',
          name: 'Guardar',
        },
        {
          icon: 'mdi-close',
          name: 'Cancelar',
        },
      ],
      title: 'Crear Método De Pago',
      apiURL: '/api/enterprises',
      method: 'POST',
    }),
    computed: {
      ref() { return this.form.id; },
    },
    async mounted() {
      await this.getBanks();
      this.URL = `${this.apiURL}/${this.enterpriseId}/payment/store`;
      if (this.id) {
          window.axios.get(`${this.apiURL}/${this.enterpriseId}/payment/${this.id}`)
          .then((result) => {
            Object.assign(this.form, result.data);
            this.URL = `${this.apiURL}/${this.enterpriseId}/payment/${this.id}/update`;
            this.method = 'PUT';
            this.title = 'Editar Método de Pago';
            this.message = `Se ha editado la numeración ${result.data.serie} exitosamente.`;
          });
      }
    },
    methods: {
        getBanks() {
          window.axios.get('api/catalogs/banks')
          .then((response) => {
            this.itemsBank = response.data.items;
          });
        },
        validate() {
            if (this.$refs.form.validate()) {
                this.snackbar = true;
                this.form.busy = true;
                if (this.form.bank_code !== this.form.bank_account.substring(0, 4)) {
                  this.$store.dispatch('notifications/show', {
                    message: 'El código de cuenta del banco no coincide con el banco seleccionado.',
                    type: 'error',
                  });
                  this.snackbar = false;
                  this.form.busy = false;
                } else {
                  this.store();
                }
            }
        },
        store() {
            window.axios({
                method: this.method,
                url: this.URL,
                data: this.form,
            })
            .then((response) => {
                if (response.data.type === 'success') {
                    this.$router.go(-1);
                }
                this.$store.dispatch('notifications/show', {
                    message: response.data.message,
                    type: response.data.type,
                });
                this.form.busy = false;
            }).catch(() => {
                this.form.busy = false;
            });
        },
        save() {
            this.validate(); // someValue
        },
        cancel() {
            this.$router.go(-1); // someValue
        },
    },
};
</script>

<style>

</style>
